import React from "react";
import { Toast, ToastContainer } from "react-bootstrap";

const ComponentToaster = (props) => {
  const { showToast, setShowToast, delay, message } = props;

  return (
    <ToastContainer className="toastContainer p-3" position="middle-center">
      <Toast onClose={() => setShowToast(false)} show={showToast} delay={delay} autohide>
        <Toast.Header>
          <img src="holder.js/20x20?text=%20" className="rounded me-2" alt="" />
          <strong className="me-auto">Information</strong>
        </Toast.Header>
        <Toast.Body>{message}</Toast.Body>
      </Toast>
    </ToastContainer>
  );
};

export default ComponentToaster;
